export const extractNumberFromPhoneFormat = (
  formattedPhoneNumber: string
): string => formattedPhoneNumber.replace(/\(|\)|\s|-/g, '')
